var _rect, _rect2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeelvar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 5.3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 48,
    height: 48,
    rx: 2.7,
    fill: "#140000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4592_239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 30,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2962 9H12V45H41.2962V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4592_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.232 9H12L29.5272 25.5824C30.2636 26.279 31.1883 26.7651 32.2029 26.9878C31.2097 27.1944 30.2978 27.6683 29.5786 28.3488L12.0043 45H22.6602L41.3005 27L22.232 9Z",
    fill: "#7878FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeelvar);
export default __webpack_public_path__ + "static/media/Keelvar.21810e8dee07666a58f076e24649822a.svg";
export { ForwardRef as ReactComponent };